import { domain } from 'modules/data';
import { integrationActions } from 'modules/integration';
import { routingService } from 'services/routing';

import { OAuthContext } from '../types';
import { getFinalUrl } from './getFinalUrl';

export const handleQBooksIntegration = async (ctx: OAuthContext) => {
    const { code, backendState, realmId, dispatch, invalidateCompanyData, createOrganisation, uiState } = ctx;

    if (uiState.type !== 'oauth') return;

    if (!realmId) {
        // Missing required parameter
        routingService.replaceToDefaultPath();

        return;
    }

    let companyId = uiState.companyId;

    if (!companyId) {
        const companyCreatedInfo = await createOrganisation(domain.IntegrationType.QBooks);

        if (companyCreatedInfo) {
            companyId = companyCreatedInfo?.CompanyId;
        } else {
            routingService.replaceToDefaultPath();

            return;
        }
    }

    // Async call, UI will show the page already
    dispatch(
        integrationActions.completeIntegrationAuth(
            {
                integrationType: domain.IntegrationType.QBooks,
                companyId,
                newCompany: !uiState.companyId,
                code,
                state: backendState,
                realmId: realmId,
            },
            invalidateCompanyData
        )
    );

    routingService.replace(getFinalUrl(uiState, companyId));
};
